import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_deadlines = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DEADLINES}/`);
};
export const dispute_resolution_getbyid_deadlines = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_DEADLINES}/by-id/${id}`);
};
export const dispute_resolution_add_deadlines = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_DEADLINES}/`, data);
};
export const dispute_resolution_update_deadlines = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_DEADLINES}/${id}`, data);
};
export const dispute_resolution_delete_deadlines = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_DEADLINES}/${id}`);
};